import React, { Component } from 'react'
import BranchForm from '../../../components/Branch/BranchForm'
import BranchListRow from '../../../components/Branch/BranchListRow'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

export  default class BranchList extends Component{
    constructor (props) {
        super(props)
        this.state = {
            lists: [],
            load_data: true,
            danger: false,
            branch_id:0,
            action: "บันทึก",
            branch: '' ,
        }
    }

    loadData () {
        axios.get(APIURL + '/branch/')
            .then(res => {
                this.setState({lists: res.data, load_data: false, branch_id: 0, danger: false})
            }).catch(error => {
            this.setState({lists: [], load_data: true, branch_id: 0, danger: false})
        })
    }

    componentDidMount () {
        //if(this.state.load_data)
        this.loadData()
    }

    toggleDanger () {
        this.setState({
            danger: !this.state.danger
        })
    }

    toggleDangerDelete (id) {
        axios.delete(APIURL + '/branch/' + id).then(res => {
            if (res.status === 200) {
                this.loadData()
                this.setState({action: "บันทึก"});
            }
        })
    }

    deleteBranch (branch) {
        this.setState({branch_id: branch.branch_id})
        this.toggleDanger()
    }

    editBranch (branch) {
        this.setState({action: "แก้ไข", branch: branch, branch_id: branch.branch_id});
    }

    addBranch(event){
        event.preventDefault()
        let that = this ;
        let branch_name = event.target.branch_name.value
        let branch_address = event.target.branch_address.value
        let branch_tel = event.target.branch_tel.value

        if(branch_name===''){
            return ;
        }

        event.target.branch_name.value = ""
        event.target.branch_address.value = ""
        event.target.branch_tel.value = ""

        axios.post(APIURL + '/branch/', {
            branch_name: branch_name,
            branch_address: branch_address,
            branch_tel : branch_tel,
            username: 'admin'
        })
            .then( res => {
                if(res.status===200) {
                  that.loadData()
                  that.setState({branch: {}, branch_id: 0, action: "บันทึก"})
                }
            })
            .catch( error => {
                console.log(error)
            })
    }

    updateBranch(event){
        event.preventDefault()
        let that = this ;
        let branch_name = event.target.branch_name.value
        let branch_address = event.target.branch_address.value
        let branch_tel = event.target.branch_tel.value
        let branch_id = this.state.branch_id;

        if(branch_name===''){
            return ;
        }
        event.target.branch_name.value = ""
        event.target.branch_address.value = ""
        event.target.branch_tel.value = ""

        axios.put(APIURL + '/branch/'+branch_id, {
            branch_id: branch_id,
            branch_name: branch_name,
            branch_address: branch_address,
            branch_tel : branch_tel,
            status_field: 'show',
            username: 'admin'
        })
            .then( res => {
                if(res.status===200) {
                  that.loadData()
                  that.setState({branch: {}, branch_id: 0, action: "บันทึก"})
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    render(){
        return (
            <div className="card">
                <div className="card-block">
                    <div className="row">

                        <div className="col-sm-8">
                            <BranchListRow
                                branch_list={this.state.lists}
                                branchsCallbacks={
                                    {
                                        delete: this.deleteBranch.bind(this),
                                        edit: this.editBranch.bind(this)
                                    }
                                }
                            />
                        </div>

                        <div className="col-sm-4">
                            <BranchForm
                                onBranchSubmit={
                                    {
                                        add: this.addBranch.bind(this),
                                        update: this.updateBranch.bind(this),
                                    }
                                }
                                actionType={this.state.action}
                                branch={this.state.branch}
                            />
                        </div>
                    </div>

                    <Modal isOpen={this.state.danger} toggle={this.toggleDanger.bind(this)}
                           className={'modal-danger '}>
                        <ModalHeader toggle={this.toggleDanger.bind(this)}>ลบข้อมูล</ModalHeader>
                        <ModalBody>
                            <strong> คุณต้องการลบข้อมูล id={this.state.branch_id} ใช่หรือไม่ ?? </strong>
                            <br />(ข้อมูลจะไม่สามารถกู้คืนได้)
                        </ModalBody>

                        <ModalFooter>
                            <Button color="primary"
                                    onClick={this.toggleDangerDelete.bind(this, this.state.branch_id)}>ตกลง</Button>{' '}
                            <Button color="secondary" onClick={this.toggleDanger.bind(this)}>ยกเลิก</Button>
                        </ModalFooter>
                    </Modal>

                </div>
            </div>
        );
    }
}